<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="10">
          <div class="editor">
            <div class="editor-header" v-if="editor">
              <button type="button" @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
                <span style="font-weight:bold">Heading</span>
              </button>
              <button type="button" @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
                <span>Body</span>
              </button>
              <button type="button" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
                <span style="font-weight:bold">B</span>
              </button>
              <button type="button" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
                <span>/</span>
              </button>
              <button type="button" @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }">
                <span style="text-decoration:underline">U</span>
              </button>
            </div>
            <editor-content class="editor-content" :editor="editor" />
          </div>
        </el-col>
        <el-col :span="10">
          <div class="listening-guide-desc">
            <div class="desc-title">
              <span>Questions the Listening Guide should answer</span>
            </div>
            <div class="desc-sub-title">
              <span>AUDIO QUALITIES</span>
            </div>
            <div class="desc-body">
              <span>What audio qualities should we listen for and on what sources? Be specific about several qualities and relate it to sources a user can listen to within your Player.</span>
            </div>
            <div class="desc-sub-title">
              <span>RELATIVE CHARACTERISTICS</span>
            </div>
            <div class="desc-body">
              <span>What is special about this product?</span>
            </div>
            <div class="desc-body">
              <span>What distinguishes it from other products in your product line?</span>
            </div>
            <div class="desc-body">
              <span>What does this product do or have that others don’t?</span>
            </div>
            <div class="desc-body">
              <span>Is it inspired by another product?</span>
            </div>
            <div class="desc-body">
              <span>What value does this product present to the user in itself and compared to the competition?</span>
            </div>
            <div class="desc-body">
              <span>What problem is this product designed to solve, in application and relative to what else is available in the market?</span>
            </div>
            <div class="desc-body">
              <span>What would make someone want to buy this product?</span>
            </div>
            <div class="desc-body">
              <span>When should someone consider a different product in your product line?</span>
            </div>
            <div class="desc-body">
              <span>What is your elevator pitch for this product?</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateProduct" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'

export default {
  name: 'TabListeningGuide',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
    EditorContent
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      editor: null,
      product: {},
      listeningGuide: {
        content: ''
      },
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
    this.initEditor()
  },
  beforeUnmount () {
    this.editor.destroy()
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.product = val
          if (val && val.listening_guide) {
            this.listeningGuide = val.listening_guide
            this.editor.commands.setContent(this.listeningGuide.content, false)
          }
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Listening Guide') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    updateProduct: function () {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'listening_guide', content: this.listeningGuide }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProduct', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    initEditor: function () {
      this.editor = new Editor({
        content: '',
        extensions: [
          StarterKit,
          Underline
        ],
        onUpdate: () => {
          this.triggerTabUpdate()
          this.listeningGuide.content = this.editor.getHTML()
        }
      })
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Listening Guide')
    }
  }
}
</script>
<style scoped lang="scss">
.editor {
  border: 1px solid #F2F2F2;
  .editor-header {
    display: flex;
    align-items: center;
    background-color: #F2F2F2;
    height: 40px;
    padding: 0 10px;
    button {
      background-color: #F2F2F2;
      border: none;
      margin: 0 15px 0 0;
      border-radius: 4px;
      cursor: pointer;
      line-height: 20px;
      &:last-child {
        margin: 0px;
      }
      &.is-active {
        background-color: black;
        color: white;
      }
    }
  }
  .editor-content {
    padding: 10px;
  }
}
.listening-guide-desc {
  .desc-title {
    font-size: 18px;
    font-weight: bold;
  }
  .desc-sub-title {
    font-weight: 300;
    margin-top: 15px;
  }
  .desc-body {
    font-style: italic;
    margin-top: 5px;
  }
}
</style>
<style lang="scss">
.ProseMirror {
  min-height: 368px;
  &:focus {
    outline: none;
  }
}
</style>
